import { AccordionProps, Box } from "@mui/material";
import { useState } from "react";
import { TIME_ZONE_MAPPER } from "../../../constants";
import Flex from "../../Flex";
import ProfileViewer from "../../ProfileViewer";
import Text from "../../Text";
import CustomAccordion from "../../CustomAccordion";

type BasicInformationProps = {
  providerData?: any;
};

const BasicInformation = ({ providerData }: BasicInformationProps) => {
  const [expanded, setExpanded] = useState(true);

  const insurances = Object.keys(providerData?.acceptedInsurances ?? {})?.length
    ? Object.values(providerData?.acceptedInsurances)?.map(
        (it, ind) => (ind + 1)?.toString() + ". " + it?.toString()
      )
    : "-";

  const workLocations = Object?.keys(providerData?.workLocations ?? {})?.length
    ? providerData?.workLocations
    : "-";

  return (
    <CustomAccordion
      expanded={expanded}
      accordionProps={
        {
          onChange: (_, isExpanded: boolean) => setExpanded(isExpanded),
        } as AccordionProps
      }
      accordionSummeryProps={{
        style: { padding: 2 },
      }}
      accordionSummaryContent={
        <Text fontWeight={450} ml={2} color="black">
          Basic Information
        </Text>
      }
      accordionDetailsContent={
        <Flex mt={"10px"} ml={2}>
          <Box width={"50%"}>
            <ProfileViewer
              gap={"14px"}
              withoutColn
              firstColW={3.5}
              secondColW={8}
              data={{
                "Office Fax Number": providerData?.officeFaxNumber,
                "Group NPI Number": providerData?.groupNpiNumber?.toString(),
                "Taxonomy Number": providerData?.taxonomyNumber,
                "Time Zone": TIME_ZONE_MAPPER[providerData?.timezone],
                "Work Location": workLocations,
              }}
            />
          </Box>
          <Box width={"50%"}>
            <ProfileViewer
              gap={"5px"}
              withoutColn
              firstColW={3.5}
              secondColW={8}
              data={{
                "Insurance(s) Accepted": insurances,
              }}
            />
          </Box>
        </Flex>
      }
    />
  );
};

export default BasicInformation;
